<template>
  <div class="dg__upload" :class="{ inline: inline }">
    <slot name="tip"></slot>
    <div class="relative">
      <div v-if="button" class="inline relative">
        <el-button :size="buttonSize"> <i class="icon">&#xe64f;</i><span class="pl-[4]">点击上传</span> </el-button>
        <input v-if="button" class="file-input dg__upload_input" type="file" :accept="type.toString()" @change="upfile" />
      </div>
      <div v-else class="relative default-img" :style="{ width: `${scale[0]}px`, height: `${scale[1]}px` }">
        <img :src="previewImg" v-if="previewImg" alt="" :style="{ width: `${scale[0]}px`, height: `${scale[1]}px` }" />
        <slot name="img" v-else></slot>
        <input :style="{ width: `${scale[0]}px`, height: `${scale[1]}px` }" class="file-input dg__upload_input" type="file" :accept="type.toString()" @change="upfile" />
      </div>
    </div>
    <div v-if="multiple && urls" class="pt-[4]">
      <div v-for="(v, index) in urls" :key="index" class="">
        <!-- el-icon-document mr-[4] -->
        <i class=" vertical-middle t-[13] el-icon-document"></i>
        <a :href="v.path" :class="{ inline: inline }" class="inline url-box vertical-middle truncate !t-[#606266]" target="_blank">
          {{ `${fileName}${index + 1}` || "附件" }}
        </a>
        <i class="icon t-[10] vertical-middle" @click="hanldeDel(v)">&#xe641;</i>
      </div>
    </div>
    <div v-if="!multiple && urls.path" class="pt-[4]">
      <i class="vertical-middle t-[13] el-icon-document"></i>
      <a :href="urls.path" :class="{ inline: inline }" class="inline url-box ertical-middle truncate !t-[#606266]" target="_blank">
        <!-- {{ urls.name || '附件' }} -->
        {{ fileName || "附件" }}
      </a>
      <i class="icon t-[10] vertical-middle" @click="hanldeDel">&#xe641;</i>
    </div>
    <div v-for="(v, index) in progress" :key="index" class="progress">
      <el-progress :percentage="v.progress"></el-progress>
    </div>
  </div>
</template>
<script>
/**
 * @author 伟健 / 张
 * @name
 */
import { remove } from "@/assets/js/utils";
export default {
  name: "dg-upload",
  componentName: "dg-upload",
  // inject: ["elForm", "elFormItem"],
  inject: {
    elForm: {
      default: "",
    },
    elFormItem: {
      default: "",
    },
  },
  props: {
    noUpload: Boolean,
    value: {
      type: [String, Array],
    },
    attrs: {
      type: Object,
      default: () => {
        return {};
      },
    },
    fileName: String,
    buttonSize: {
      type: String,
      default: "small",
    },
    size: {
      type: Number,
      default: 50,
    },
    accept: {
      type: String,
      default: "image/png, image/jpeg, image/jpg",
    },
    type: {
      type: Array,
      default: () => {
        return [".jpg", ".jpeg", ".png"];
      },
    },
    scale: {
      type: Array,
      default: () => {
        return [100, 100];
      },
    },
    button: Boolean,
    inline: Boolean,
  },
  data() {
    return {
      urls: {},
      multiple: false,
      previewImg: "",
      progress: [],
    };
  },
  watch: {
    value: {
      handler(val) {
        if (!val) {
          this.urls.path = "";
        }
        if (val instanceof Array) {
          this.multiple = true;
          this.urls = val;
        }
        if (typeof val == "string") {
          this.urls.path = val;
          this.previewImg = val;
          this.multiple = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * @author 伟健 / 张
     * @name 删除
     */
    hanldeDel(row) {
      if (this.multiple) {
        remove(this.urls, row);
        this.$emit("input", this.urls);
      } else {
        this.previewImg = "";
        this.urls = {
          path: "",
          name: "",
        };
        this.$emit("input", "");
      }
      this.$emit("change", { url: "", name: "" });
      if (this.elFormItem) {
        this.elFormItem.validate("change");
      }
    },
    upfile(e) {
      var file = e.target.files[0]; //获取上传的文件
      let { size, name } = file;
      var suffix = this.getSuffix(name);
      var maxSize = 1048576 * this.size; //最大5MB
      if (size > maxSize) {
        // this.$message({
        //   message: `上传的文件不能超过${this.size}MB`,
        //   type: "error",
        // });
        Mirror.emit("tips_dg_alert_box_open", {
          msg: `上传的文件不能超过${this.size}MB`,
          type: "error",
        });
        return;
      }

      if (this.type.length && this.type.indexOf(suffix) == -1 && this.type[0] != "*") {
        // this.$message({
        //   message: `文件类型错误,请上传${this.type.join(" ")}`,
        //   type: "error",
        // });
        Mirror.emit("tips_dg_alert_box_open", {
          msg: `文件类型错误,请上传${this.type.join(" ")}`,
          type: "error",
        });
        // tips_dg_alert_box_open
        return;
      }
      var formData = new FormData();
      formData.append("fileName", file);
      this.$emit("file", file);
      if (this.noUpload) {
        return;
      }

      this.progress.push({
        progress: 0,
      });
      let index_progress = this.progress.length - 1;
      ajax.uploadFile({
        url: "/supplyChain/upload",
        data: formData,
        self: this,
        onUploadProgress: (progress) => {
          this.progress[index_progress].progress = progress;
        },
        success: (res) => {
          remove(this.progress, this.progress[index_progress]);
          if (res) {
            remove(this.progress, this.progress[index_progress]);
            this.previewImg = res;

            try {
              if (this.multiple) {
                let d = { ...this.attrs };
                if (this.attrs && this.attrs["key"]) {
                  d[this.attrs["key"]] = res;
                } else {
                  d["path"] = res;
                }
                d["name"] = file.name;
                if (this.attrs && Object.property.hasOwnProperty.call(this.attrs, "size")) {
                  d["size"] = file.size;
                }
                delete d["key"];
                this.urls.push(d);
                this.$emit("input", this.urls);
              } else {
                this.urls.name = name;
                this.urls.path = res;
                this.$emit("input", res);
              }
            } catch (e) {
              console.log(e);
            }
            this.$emit("change", { url: res, name, key: this.attrs["key"] || "" });
            if (this.elFormItem && this.elFormItem.prop) {
              this.elFormItem.clearValidate(this.elFormItem.prop);
            }
            this.url = res;
          }
          e.target.value = "";
        },
        fail: () => {
          remove(this.progress, this.progress[index_progress]);
          e.target.value = "";
          // this.$message({ message: `图片上传失败`, type: "error" });
          Mirror.emit("tips_dg_alert_box_open", {
            msg: `图片上传失败`,
            type: "error",
          });
        },
      });
    },
    getSuffix(str) {
      var d = str.split(".");
      return "." + d[d.length - 1];
    },
  },
  mounted() {
    console.log();
    console.log();
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/css/var.less';
.dg__upload {
  min-width: 120px;
  line-height: normal;

  &.inline {
    display: inline-block;
    margin-right: 10px;
    vertical-align: top;
  }

  .file-input {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 5;
    cursor: pointer;
    opacity: 0;
  }

  .progress {
    width: 130px;
  }

  .default-img {
    border-radius: 5px;
    overflow: hidden;
    background: #eee;
  }

  .default-img img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    display: block;
  }

  .preview {
    position: absolute;
    top: 1%;
    left: 1%;
    width: 98%;
    height: 98%;
    object-fit: cover;
    object-position: center;
    display: block;
    border-radius: 4px;
  }

  .url-box {
    width: 100px;
    color: #c7c7c7;
    font-size: 12px;
    // padding-top: 5px;
    text-decoration: none;
    &.inline {
      width: 170px;
    }
  }

  a:hover {
    text-decoration: underline;
    color: #c7c7c7;
  }
}

.img-upload {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  border: 1px dashed #c7c7c7;
  cursor: pointer;

  i {
    margin: auto;
    font-size: 30px;
    color: #c7c7c7;
  }
}

.tip {
  font-size: 12px;
  color: #c7c7c7;
  padding-top: 5px;
}
</style>
<style>
.dg__upload .el-progress-bar__outer {
  height: 3px !important;
}

.dg__upload .el-progress__text {
  font-size: 12px !important;
}
</style>
 <style>.pl-\[4\] {
    padding-left: 4px
}
.pt-\[4\] {
    padding-top: 4px
}
.t-\[13\] {
    font-size: 13px
}
.\!t-\[\#606266\] {
    color: #606266 !important
}
.t-\[10\] {
    font-size: 10px
}
.inline {
    display: inline
}
.relative {
    position: relative
}
.vertical-middle {
    vertical-align: middle
}
.truncate {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap
}</style>